import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Dropdown, Menu} from 'antd'
import { QuestionCircleFilled, EditOutlined, DeleteOutlined, ExclamationCircleFilled} from '@ant-design/icons'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import AddFormModal from './AddFormModal'
import ViewFormModal from './ViewFormModal'
import FormImport from './FormImport'
import ResourcePoolList from '../../marketingResourcePool/components/ResourcePoolList'
import {withTranslation} from 'react-i18next'
const {confirm} = Modal

@inject('emailAddressStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    modalVisibleAdd: false,
    modalVisibleView: false,
    importModalVisible: false,
    record: null,
    detailsModalVisible: false,
    poolObj: null,
  }

  componentDidMount() {
  }

  handleEdit = (record) => {
    const {emailAddressStore} = this.props
    const {searchItem} = emailAddressStore
    emailAddressStore.onGetJobAction({
      id: record.id,
      marketGroupId: searchItem?.marketGroupId
    }).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {emailAddressStore,t} = this.props
    const {searchItem} = emailAddressStore
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        emailAddressStore.onDeleteJobAction({
          "id": record?.id,
          "marketGroupId": searchItem?.marketGroupId
        })
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {emailAddressStore} = this.props
    emailAddressStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleAdd = (record) => {
    this.setState({
      modalVisibleAdd: true,
      record: record
    })
  }
  handleCancelAdd = () => {
    this.searchAction()
    this.setState({
      modalVisibleAdd: false,
      record: null
    })
  }
  //查看地址
  handleView = (record) => {
    const {emailAddressStore} = this.props
    const {searchItem} = emailAddressStore
    emailAddressStore.onDetailsListAction({
      id: record.id,
      marketGroupId: searchItem?.marketGroupId
    }).then(res => {
      this.setState({
        modalVisibleView: true,
        record: record
      })
    })
  }
  handleCancelView = () => {
    this.searchAction()
    this.setState({
      modalVisibleView: false,
      record: null
    })
  }
  // 点击按钮 文件导入
  handleImport = (record) => {
    this.setState({
      importModalVisible: true,
      sourceType: '2',
      record: record
    })
  }
  handleCancelImport = () => {
    this.searchAction()
    this.setState({
      importModalVisible: false,
      sourceType: '',
      record: null
    })
  }
  // 点击按钮 资源池导入
  handlePoolImport = (e, obj, record) => {
    this.setState({
      detailsModalVisible: true,
      sourceType: '3',
      poolObj: obj,
      record: record,
    })
  }
  handleCancelPoolImport = () => {
    this.searchAction()
    this.setState({
      detailsModalVisible: false,
      sourceType: '',
      record: null
    })
  }
  searchAction=()=> {
    const {emailAddressStore} = this.props
    const {searchItem} = emailAddressStore
    emailAddressStore.onSearchJobAction({
      page: 1, 
      size: PAGE_SIZE_DEFAULT, 
      marketGroupId: searchItem?.marketGroupId
    })
  }
  render() {
    const {emailAddressStore, t} = this.props
    const {searchItem, pageNo, pageSize, itemCount, jobList, groupList, resourcePoolList} = emailAddressStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <div className="searchResult">
        <div className='tips_box'>
          <div className='f_red'><ExclamationCircleFilled /> 温馨提示:</div>
          <div>1、操作栏点击修改可以获取该联系人分类对应的“订阅插件代码”；</div>
          <div>2、无效地址率=(格式错误地址+无效地址库命中的地址) / (总地址-重复地址)，这个无效地址率仅是在导入邮件地址时的数据清洗统计，越高说明地址质量越差；</div>
          <div>3、群发任务调用联系人分类发送任务完毕后，系统默认自动将无效邮件地址从该联系人分类中移除；</div>
          <div>4、平台在邮件发送中如果发现收件人地址是无效地址，会自动拦截无效地址发送；</div>
          <div>5、平台在邮件发送中如果有人投诉该地址，该地址也会从当前地址池中删除；</div>
          <div>6、邮件地址中如果发送QQ或网易的邮件地址中的无效邮件地址比例高于15%，则该部分种类邮件会被中止投递！</div>
        </div>
        <Table dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column title={t(`emailSend.marketingGroup`)} dataIndex="groupName" key="groupName" ellipsis={true} render={(text, record) => (
            <>
            {groupList?.find(a=>a?.id===searchItem?.marketGroupId)?.groupName}
            </>
          )} />
          <Table.Column title={t(`emailSend.className`)} dataIndex="subject" key="subject" ellipsis={true} />
          <Table.Column title={t(`emailSend.remark`)} dataIndex="description" key="description" ellipsis={true} />
          <Table.Column title='创建时间' dataIndex="createTime" key="createTime" ellipsis={true} />
          <Table.Column title='地址数量' dataIndex="count" key="count" ellipsis={true} />
          {/* <Table.Column title='订阅' dataIndex="count" key="count" ellipsis={true} />
          <Table.Column title='退订' dataIndex="count" key="count" ellipsis={true} />
          <Table.Column title='投诉' dataIndex="count" key="count" ellipsis={true} /> */}
          <Table.Column title='无效地址' dataIndex="countErr" key="countErr" ellipsis={true} />
          <Table.Column width={400} align="center" title={t(`emailSend.emailAddress`)} dataIndex="groupName" key="groupName" ellipsis={true} render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleAdd(record)}>{t(`emailSend.emailAddressAdd`)}</Button>
              <Button type="link" onClick={() => this.handleImport(record)}>{t(`emailSend.fileImport`)}</Button>
              <Dropdown overlay={(<Menu>
                {resourcePoolList?.map((b,i)=><Menu.Item key={i}><a onClick={e=>this.handlePoolImport(e, b, record, true)}>{b?.resourcePoolName}</a></Menu.Item>)}
              </Menu>)} placement="bottomLeft" >
                <Button type="link" onClick={e => e.preventDefault()} >{t(`emailSend.poolImport`)}</Button>
              </Dropdown>
              
              <Button type="link" onClick={() => this.handleView(record)}>{t(`emailSend.emailAddressView`)}</Button>
            </>
          )}/>
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
        {this.state.modalVisibleAdd ? <AddFormModal
          addModalVisible={this.state.modalVisibleAdd}
          handleCancel={this.handleCancelAdd}
          record={this.state.record}
        /> : null}
        {this.state.modalVisibleView ? <ViewFormModal
          addModalVisible={this.state.modalVisibleView}
          handleCancel={this.handleCancelView}
          record={this.state.record}
        /> : null}
        {this.state.importModalVisible ? <FormImport 
          handleCancel={this.handleCancelImport} 
          importModalVisible={this.state.importModalVisible} 
          record={this.state.record}
        /> : null}
        {this.state.detailsModalVisible ? 
          <ResourcePoolList handleCancel={this.handleCancelPoolImport} addModalVisible={this.state.detailsModalVisible} poolObj={this.state.record} record={this.state.poolObj} marketGroupId={searchItem?.marketGroupId} isSelect={true} type='3' /> 
        : null}
      </div>
    )
  }
}

export default withTranslation()(SearchResult)
